import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';

const ToolbarBase = Styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 10px 10px;
  background: ${Colors.white};
  box-shadow: 0px 0px 10px rgba(${Colors.blackRGB}, 0.1);

  &.left {
    justify-content: flex-start;
  }

  &.right {
    justify-content: flex-end;
  }

  > * {
    margin-right: 5px;
  }

  :last-child {
    margin-right: 0px;
  }
`;

const StyledNekoToolbar = (props) => {
  const { align = 'left' } = props;
  return (
    <ToolbarBase className={align}>
      {props.children}
    </ToolbarBase>
  );
};

const NekoToolbar = (props) => {
  return (<StyledNekoToolbar {...props} />);
};

NekoToolbar.propTypes = {
  align: PropTypes.oneOf(['left', 'right'])
};

NekoToolbar.defaultProps = {
  align: 'left'
};

export { NekoToolbar };